import axios from '../library/axiosConfig.js';
let renterOperation = axios.defaults.renterOperation;
let authUrl = renterOperation + '/authorize';
let permissionUrl = renterOperation + '/renterPermission';


export default {
  // 银联获取appid
  // channel 银联54
  unionPayGetAppid (data) {
    return axios.post('/appid', data, {baseURL: authUrl})
  },
  // 银联授权
  // channel 银联54
  // code
  unionPayAuthorize (data) {
    return axios.post('/doAuthorize', data, {baseURL: authUrl})
  },
  /**
   *  获取手机验证码
   * @param data {mobile, channel, bizType}
   * @returns {AxiosPromise<any>}
   */
  sendVerifyCode (data) {
    return axios.post('/sendMessageSecurityCode', data, {baseURL: permissionUrl});
  },
  /**
   *  检查验证码是否正确
   * @param data {mobile, code}
   * @returns {AxiosPromise<any>}
   */
  checkSecurityCode (data) {
    return axios.post('/checkSecurityCode', data, {baseURL: permissionUrl});
  },
  /**
   * 手机验证码登录
   * @param data {mobile, channel, mobileVerifyCode}
   * @returns {AxiosPromise<any>}
   */
  loginByVerifyCode (data) {
    return axios.post('/verifyCodeLogin', data, {baseURL: permissionUrl});
  },
  /**
   * 获取图片验证码
   * @param uuid
   * @param channel
   * @returns {string}
   */
  getImgVerifyCode (uuid, channel) {
    return permissionUrl + `/getPicVeriCode` + `?picVerifyCodeToken=${uuid}&channel=${channel}&t=${+new Date()}`;
  },
  /**
   * 获取用户信息
   * @version 银联
   * @param {Object} params
   */
  getRenterInfo (params) {
    return axios.post('/info/getRenterInfoByUserId', params, {baseURL: renterOperation})
  },
  // 获取frontSignature
  // channel 银联54 url
  frontUpsdkSignature (data) {
    return axios.post('/frontSignature', data, {baseURL: authUrl});
  },
  loadAppIdConfig () {
    return axios.get('/loadAppIdConfig', {baseURL: authUrl});
  },
  //微信公众号授权接口查询用户信息
  authWeChatCallBackPage (data) {
    return axios.post('/authWeChatCallBackPage', data, {baseURL: authUrl})
  },
  //支付宝授权接口查询用户信息
  authAliPayCallBackPage (data) {
    return axios.post('/authAliPayCallBackPage', data, {baseURL: authUrl})
  },
  //获取微信公众号JSSDK签名
  getWeChatSignature (data) {
    return axios.get('/getWeChatSignature', {params:data ,baseURL: authUrl})
  },
  //用户房东关系绑定
  renterLandlordRelationBind (data) {
    return axios.post('/renterLandlordRelation/bind', data, {baseURL: renterOperation})
  },
  // 根据租客id和渠道查询租客绑定信息(1表示绑定，0表示取消绑定)
  findUserWxBindByUserId(data) {
    return axios.get(`/findUserWeixinBindByUserId`, { params: data, baseURL: authUrl });
  }
}



// WEBPACK FOOTER //
// ./src/api/authorize.js